import $ from "jquery";

const AnimateNumber = {
    // numb_start Получаем начальное число
    // number_end Получаем конечное число
    /**
     *
     * @param numb_start int Получаем начальное число
     * @param number_end int Получаем конечное число
     * @param executeElement jqueryObject элемент на который будет производится действие
     * @param hint string Текст перед выводом результата
     * @param calculate Доп функция для обработки результата
     * @param duration int Продолжительность анимации, где 500 = 0,5 одной секунды, то есть 500 миллисекунд
     * @param easing string Тип анимации
     */
    animate({numb_start = 0, number_end = 1000, executeElement, hint = '', calculate = fn(), duration = 500, easing = "linear"}) {
        $({numberValue: numb_start}).animate({numberValue: number_end}, {
            duration: duration,
            easing: easing,
            step: function (val) {
                executeElement.html(hint + calculate(val))
            }
        });
    }
}

export default AnimateNumber;